import type { PayloadAction } from '@reduxjs/toolkit';

const setIsOnline = (state, action: PayloadAction<boolean>) => {
  state.isOnline = action.payload;
};

const setLanguageCode = (state, action: PayloadAction<string>) => {
  state.languageCode = action.payload;
};

const setBackgroundWorker = (state, action: PayloadAction<any>) => {
  state.backgroundWorker = action.payload;
};

const setIsSupervisorMode = (state, action: PayloadAction<boolean>) => {
  state.isSupervisorMode = action.payload;
};

const setLockedProject = (state, action: PayloadAction<{ label: string; value: string } | null>) => {
  state.lockedProject = action.payload;
};

export { setIsOnline, setLanguageCode, setBackgroundWorker, setIsSupervisorMode, setLockedProject };
